import { render, staticRenderFns } from "./DailyTxFees.vue?vue&type=template&id=67560e6f&scoped=true&"
import script from "./DailyTxFees.vue?vue&type=script&lang=js&"
export * from "./DailyTxFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67560e6f",
  null
  
)

export default component.exports